import axios from "axios";
import toast from "react-hot-toast";

/**
 * Returns a new items array where the given service has the specified field flipped.
 * @param {Array} items - Current items state
 * @param {number|string} id - Service ID to update
 * @param {string} field - Boolean field name to flip ("hidden" | "test")
 * @returns {Array} New items array with the optimistic update applied
 */
function flipServiceField(items, id, field) {
    return items.map((s) => (s.id === id ? { ...s, [field]: !s[field] } : s));
}

/**
 * PUTs /admin/services/switch_hidden/<id> with optimistic update.
 * On failure, rolls the local state back to the previous value and surfaces a toast.
 * @param {Object} args - { service, items, setItems }
 * @returns {Promise<void>}
 */
export async function toggleHiddenAction({ service, items, setItems }) {
    const id = service?.id;
    if (!id) return;
    const previous = service.hidden;
    setItems(flipServiceField(items, id, "hidden"));
    try {
        await axios.put(`/admin/services/switch_hidden/${id}`);
        toast.success(previous ? "Service rendu visible" : "Service masqué");
    } catch (error) {
        setItems(items);
        const msg = error?.response?.data || "Échec de la mise à jour";
        toast.error(typeof msg === "string" ? msg : "Échec de la mise à jour");
    }
}

/**
 * PUTs /admin/services/switch_test/<id> with optimistic update.
 * @param {Object} args - { service, items, setItems }
 * @returns {Promise<void>}
 */
export async function toggleTestAction({ service, items, setItems }) {
    const id = service?.id;
    if (!id) return;
    const previous = service.test;
    setItems(flipServiceField(items, id, "test"));
    try {
        await axios.put(`/admin/services/switch_test/${id}`);
        toast.success(previous ? "Mode test désactivé" : "Mode test activé");
    } catch (error) {
        setItems(items);
        const msg = error?.response?.data || "Échec de la mise à jour";
        toast.error(typeof msg === "string" ? msg : "Échec de la mise à jour");
    }
}
